export enum FAQSlug {
  VirtualWarehouse = 'virtual-warehouse-faq',
  PromoCodes = 'promo-code-faq',
  SharedBaskets = 'shared-basket-faq'
}
